// @flow

import React from "react";
import { getClassName, addModifierTo } from "ui-kit/utils/component";
import cx from "classnames";
import "./Input.scss";

const ccn = getClassName("Input");

type Props = {
  className?: string,
  isDisabled?: boolean,
  inputRef?: Function,
  input?: any,
  val?: any,
  meta?: any,
  label?: string,
  className?: string,
  paddingTop?: boolean,
  white?: boolean,
  clearServerError?: Function
};

const UNIT = {
  percentage: "%",
  USD: "$",
  EUR: "€",
  BTC: "฿"
};

const UNIT_POSITION = {
  left: "left",
  right: "right"
}

export default (props: Props) => {
  const {
    isDisabled,
    inputRef = () => {},
    input,
    val,
    meta = {},
    label,
    className,
    paddingTop,
    clearServerError,
    white,
    unit,
    unitPosition = UNIT_POSITION.right,
    ...rest
  } = props;

  const msg = meta.error || meta.warning;

  const modify = addModifierTo(ccn());

  const classes = cx(ccn(), {
    [modify("disabled")]:    meta.submitting || isDisabled,
    [modify("valid")]:       meta.touched && meta.valid,
    [modify("invalid")]:     meta.touched && meta.invalid,
    [modify("hidden")]:      props.type === "hidden",
    [modify("padding-top")]: paddingTop,
    [modify("white")]: white
  }, className);

  return (
    <div className={classes} onClick={meta.error!==undefined?clearServerError:null}>
      {label && <div className={cx(`${ccn("label")}`)}>{label}</div>}
      <div className={ccn("wrapper")}>
        {unit && (
          <span
            className={cx(ccn("unit"), ccn(`unit-${unit}`), ccn(`unit-position_${UNIT_POSITION[unitPosition]}`))}
          >
            {UNIT[unit]}
          </span>
        )}
        <input
          {...input}
          {...rest}
          onClick={e => e.target.select()}
          className={ccn("field")}
          value={val}
          ref={(ref) => { inputRef(ref); }}
        />
      </div>
      {meta.touched && msg && <div className={ccn("validationMsg")}>{msg}</div>}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/ui-kit/components/input/Input.js